import { Component } from '@angular/core';

@Component({
  selector: 'app-success',
  standalone: false,
  templateUrl: './success.component.html',
  styleUrl: './success.component.less'
})
export class SuccessComponent {

}
